/* Memodec Mix — small behaviours for the mm-* sections. No dependencies. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* keep sticky filter bar just under the sticky header */
  const header = document.querySelector('.mm-header-section, .section-header');
  const setH = () => document.documentElement.style.setProperty('--mm-header', (header ? header.getBoundingClientRect().height : 0) + 'px');
  setH(); addEventListener('resize', setH, { passive: true });

  /* ---------- quick add: with a scale filter active, add that scale directly; otherwise "Choose scale" ---------- */
  const variantsOf = (btn) => { try { return JSON.parse(btn.dataset.variants || '[]'); } catch (e) { return []; } };
  const syncQuick = (root, scale) => {
    root.querySelectorAll('[data-mm-quick]').forEach((btn) => {
      const vs = variantsOf(btn);
      if (vs.length <= 1) return;
      const span = btn.querySelector('span');
      const hit = scale !== 'all' && vs.find((v) => v.t === scale && v.a);
      if (hit) { btn.dataset.mmAdd = hit.id; span.textContent = `Add to cart · ${hit.t}`; }
      else { delete btn.dataset.mmAdd; span.textContent = 'Choose scale'; }
    });
  };
  const setPop = (p, open) => {
    p.hidden = !open; const b = p.parentElement.querySelector('[data-mm-quick]'); if (b) b.setAttribute('aria-expanded', String(open));
    // inside a horizontal scroll row (new liveries) the row clips anything below the card: pin the popover to the viewport instead
    if (open && b && p.closest('.mm-new')) { const r = b.getBoundingClientRect(); p.style.cssText = `position:fixed;left:${r.left}px;width:${r.width}px;top:${r.bottom + 6}px;bottom:auto;right:auto`; popAt = Date.now(); }
    else p.style.cssText = '';
  };
  let popAt = 0; // focus/snap scrolls fire right after opening; only a later scroll closes the pinned popover
  addEventListener('scroll', () => { if (Date.now() - popAt > 300) closePops(); }, { passive: true, capture: true });
  const closePops = (except) => document.querySelectorAll('[data-mm-scalepop]:not([hidden])').forEach((p) => { if (p !== except) setPop(p, false); });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mm-quick]');
    if (!btn) { if (e.target.closest('[data-mm-scalepop]')) e.preventDefault(); else closePops(); return; }
    if (btn.dataset.mmAdd) return; // handled by the add-to-cart handler
    e.preventDefault(); e.stopPropagation();
    const pop = btn.parentElement.querySelector('[data-mm-scalepop]');
    if (!pop) return;
    if (!pop.hidden) { setPop(pop, false); return; }
    const esc = (t) => String(t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
    const nm = btn.dataset.mmName || ''; // the popover covers the card title, so it repeats the decal name
    pop.innerHTML = (nm ? `<span class="mm-scalepop__title">${esc(nm)}</span><span class="mm-scalepop__sub">Choose your scale</span>` : '<span class="mm-scalepop__title">Choose your scale</span>') + variantsOf(btn).map((v) =>
      `<button type="button" class="mm-scaleopt" ${v.a ? `data-mm-add="${v.id}"` : 'disabled'}><span>${esc(v.t)}</span><small>${v.a ? esc(v.p) : 'Sold out'}</small></button>`).join('');
    closePops(pop);
    setPop(pop, true);
  }, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePops(); });

  /* text matching shared by the live search and the collection text filter: letters/digits only ("dc3" = "DC-3"),
     word prefixes, one typo tolerated from four letters */
  const mmCompact = (t) => String(t).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '');
  const mmTokens = (t) => String(t).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(/[^a-z0-9]+/).filter(Boolean);
  const mmNear = (a, b) => {
    if (a === b) return true; if (a.length < 4 || Math.abs(a.length - b.length) > 1) return false;
    let i = 0; while (i < a.length && i < b.length && a[i] === b[i]) i++;
    if (a.length === b.length) return a.slice(i + 1) === b.slice(i + 1) || (a[i] === b[i + 1] && a[i + 1] === b[i] && a.slice(i + 2) === b.slice(i + 2));
    return a.length > b.length ? a.slice(i + 1) === b.slice(i) : a.slice(i) === b.slice(i + 1);
  };
  const mmTextMatch = (hay, q) => { // every query word must start a word of the text (or be one typo away); "dc3" also matches as a compact substring
    const qt = mmTokens(q); if (!qt.length) return true;
    const hc = mmCompact(hay), hk = mmTokens(hay);
    // a loose substring match only for codes with digits or longer fragments, otherwise "ana" would hit Canadair and Mandala
    return qt.every((t) => ((/\d/.test(t) || t.length >= 5) && hc.includes(t)) || hk.some((k) => k.startsWith(t) || mmNear(t, k) || (k.length > t.length && mmNear(t, k.slice(0, t.length)))));
  };

  /* ---------- shop filters (maker + decade chips + airline text) ---------- */
  document.querySelectorAll('[data-mm-shop]').forEach((shop) => {
    const state = { maker: 'all', decade: 'all', scale: 'all', type: 'all', typeLabel: '', q: '' };
    shop.mmState = state;
    // filters live in the URL (?scale=1/144&decade=1970s) so back/forward and shared links keep them
    const qs = new URLSearchParams(location.search);
    ['maker', 'decade', 'scale', 'type'].forEach((k) => { if (qs.get(k)) state[k] = qs.get(k); });
    const ftext = shop.querySelector('[data-mm-ftext]'), fclear = shop.querySelector('[data-mm-ftext-clear]');
    if (ftext && qs.get('airline')) { state.q = qs.get('airline'); ftext.value = state.q; }
    if (state.type !== 'all') { const chip = shop.querySelector(`[data-mm-chip][data-key="type"][data-value="${CSS.escape(state.type)}"]`); state.typeLabel = chip ? chip.textContent.trim() : ''; }
    const writeUrl = () => {
      const u = new URL(location.href);
      ['maker', 'decade', 'scale', 'type'].forEach((k) => { if (state[k] === 'all') u.searchParams.delete(k); else u.searchParams.set(k, state[k]); });
      if (state.q) u.searchParams.set('airline', state.q); else u.searchParams.delete('airline');
      if (u.href !== location.href) history.replaceState(history.state, '', u);
    };
    const cards = [...shop.querySelectorAll('[data-mm-card]')].filter((c) => !c.closest('[data-mm-static]')); // static groups (search "also mention") are not filtered
    const count = shop.querySelector('[data-mm-count]');
    const empty = shop.querySelector('[data-mm-empty]');

    const step = Number(shop.dataset.mmPage) || 12;
    let limit = step;
    const moreBtn = shop.querySelector('[data-mm-more]');
    // does a card fit a filter state? (used for the grid and for hiding chips that would lead to an empty result)
    const fits = (c, st) => (st.maker === 'all' || c.dataset.maker === st.maker) &&
                            (st.decade === 'all' || c.dataset.decade === st.decade) &&
                            (st.scale === 'all' || (' ' + (c.dataset.scales || '') + ' ').includes(' ' + st.scale + ' ')) &&
                            (st.type === 'all' || c.dataset.type === st.type) &&
                            (!st.q || mmTextMatch(c.dataset.search || '', st.q));
    const apply = () => {
      let shown = 0;
      let matches = 0;
      cards.forEach((c) => {
        const match = fits(c, state);
        if (match) matches++;
        const ok = match && matches <= limit;
        if (ok) shown++;
        if (reduce) { c.hidden = !ok; return; }
        if (ok && c.hidden) {
          c.hidden = false; c.classList.add('mm-out');
          requestAnimationFrame(() => requestAnimationFrame(() => {
            c.style.transitionDelay = Math.min(shown * 20, 120) + 'ms';
            c.classList.remove('mm-out');
            setTimeout(() => (c.style.transitionDelay = ''), 360);
          }));
        } else if (!ok && !c.hidden) {
          c.classList.add('mm-out');
          setTimeout(() => { if (c.classList.contains('mm-out')) c.hidden = true; }, 130);
        }
      });
      if (count) count.textContent = matches;
      const noun = shop.querySelector('[data-mm-count-noun]'); if (noun) noun.textContent = matches === 1 ? 'decal' : 'decals';
      if (empty) empty.hidden = matches !== 0;
      if (moreBtn) moreBtn.hidden = matches <= limit;
      shop.querySelectorAll('[data-mm-chip]').forEach((b) =>
        b.setAttribute('aria-pressed', String(state[b.dataset.key] === b.dataset.value)));
      syncQuick(shop, state.scale);
      writeUrl();
      const act = shop.querySelector('[data-mm-active]');
      if (act) { // "Showing: Boeing 737-200 · 1/144" with one clear chip per active filter (the finder arrives with both)
        // one chip per active filter, each showing its value with an ✕ (the chip is the state, the ✕ removes it)
        const dec = state.decade === 'all' ? '' : (/^\d+$/.test(state.decade) ? `${state.decade}s` : state.decade);
        const chips = [['[data-mm-clear-type]', state.typeLabel], ['[data-mm-clear-scale]', state.scale !== 'all' ? state.scale : ''], ['[data-mm-clear-decade]', dec], ['[data-mm-clear-q]', state.q ? `“${state.q}”` : '']];
        let any = false;
        chips.forEach(([sel, val]) => { const b = act.querySelector(sel); if (!b) return; b.hidden = !val; if (val) { b.textContent = `${val} ✕`; any = true; } });
        act.hidden = !any;
        if (fclear) fclear.hidden = !state.q;
      }
    };

    shop.addEventListener('click', (e) => {
      if (e.target.closest('[data-mm-more]')) { limit += step; apply(); return; }
      if (e.target.closest('[data-mm-clear-type]')) { state.type = 'all'; state.typeLabel = ''; limit = step; apply(); return; }
      if (e.target.closest('[data-mm-clear-scale]')) { state.scale = 'all'; limit = step; apply(); return; }
      if (e.target.closest('[data-mm-clear-decade]')) { state.decade = 'all'; limit = step; apply(); return; }
      if (e.target.closest('[data-mm-clear-all]')) { Object.assign(state, { maker: 'all', decade: 'all', scale: 'all', type: 'all', typeLabel: '', q: '' }); if (ftext) ftext.value = ''; limit = step; apply(); shop.scrollIntoView({ block: 'start', behavior: 'smooth' }); return; }
      if (e.target.closest('[data-mm-clear-q], [data-mm-ftext-clear]')) { state.q = ''; if (ftext) { ftext.value = ''; ftext.focus(); } limit = step; apply(); return; }
      const b = e.target.closest('[data-mm-chip]');
      if (!b) return;
      state[b.dataset.key] = b.dataset.value;
      if (b.dataset.key === 'type') state.typeLabel = b.dataset.value === 'all' ? '' : b.textContent.trim(); // chip click shows the type in the Showing row like the finder does
      limit = step;
      apply();
    });
    if (ftext) {
      let ft = 0;
      ftext.addEventListener('input', () => { clearTimeout(ft); ft = setTimeout(() => { state.q = ftext.value.trim(); limit = step; apply(); }, 60); });
      ftext.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); ftext.blur(); } if (e.key === 'Escape' && ftext.value) { e.stopPropagation(); ftext.value = ''; state.q = ''; limit = step; apply(); } });
    }
    shop.mmFilter = (key, value) => { state.maker = 'all'; state.decade = 'all'; state[key] = value; limit = step; apply(); };
    shop.mmFind = (type, label, scale) => { state.maker = 'all'; state.decade = 'all'; state.type = type || 'all'; state.typeLabel = label || ''; state.scale = scale || 'all'; limit = step; apply(); };
    apply();
  });

  /* decade cards and collection banners can drive the shop filter */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-mm-filter]');
    if (!t) return;
    const shop = document.querySelector('[data-mm-shop]');
    if (!shop || !shop.mmFilter) return;
    e.preventDefault();
    const [key, value] = t.dataset.mmFilter.split(':');
    shop.mmFilter(key, value);
    shop.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- quick add (uses the theme's cart drawer when present) ---------- */
  const swap = (btn, text) => {
    const span = btn.querySelector('span') || btn;
    btn.classList.add('mm-swap');
    setTimeout(() => { span.textContent = text; btn.classList.remove('mm-swap'); }, 150);
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-mm-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    const label = btn.querySelector('span')?.textContent || '';
    btn.disabled = true;
    const drawer = document.querySelector('cart-drawer');
    const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
    try {
      const res = await fetch(window.Shopify?.routes?.root ? `${Shopify.routes.root}cart/add.js` : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(btn.dataset.mmAdd), quantity: 1, sections, sections_url: window.location.pathname }),
      });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || 'Could not add');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
        drawer.renderContents(json);
      } else if (json.sections && json.sections['cart-icon-bubble']) {
        const el = document.getElementById('cart-icon-bubble');
        const html = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (el && html) el.innerHTML = html.innerHTML;
      }
      swap(btn, btn.dataset.mmAdded || 'Added ✓');
      const pop = btn.closest('[data-mm-scalepop]'); if (pop) setTimeout(() => { setPop(pop, false); }, 900);
    } catch (err) {
      swap(btn, /sold out|can.t add more/i.test(err.message) ? 'Sold out' : 'Not added, try again');
    } finally {
      setTimeout(() => { swap(btn, label); btn.disabled = false; }, 1600);
    }
  });


  /* ---------- product top: gallery, zoom, variants, quantity, add to cart ---------- */
  document.querySelectorAll('[data-mm-pdp]').forEach((root) => {
    const stage = root.querySelector('[data-mm-stage]');
    const main = root.querySelector('[data-mm-main]');
    const zoomBtn = root.querySelector('[data-mm-zoom]');
    let gen = 0;
    const pct = (e) => { const r = stage.getBoundingClientRect(); return [(e.clientX - r.left) / r.width * 100, (e.clientY - r.top) / r.height * 100]; };
    const zoom = (x, y) => {
      const on = !stage.classList.contains('is-zoomed');
      if (on) main.style.transformOrigin = `${x ?? 50}% ${y ?? 50}%`;
      stage.classList.toggle('is-zoomed', on);
      swap(zoomBtn, on ? 'Close zoom' : 'Zoom');
    };
    // zoom removed on purpose (copy protection): the images are uploaded small + watermarked, enlarging them only enlarges the grid
    root.querySelectorAll('[data-mm-thumb]').forEach((t) => t.addEventListener('click', () => {
      if (t.getAttribute('aria-current') === 'true') return;
      const my = ++gen;
      root.querySelectorAll('[data-mm-thumb]').forEach((x) => x.setAttribute('aria-current', String(x === t)));
      if (stage.classList.contains('is-zoomed')) zoom();
      main.classList.add('mm-leaving');
      setTimeout(() => {
        if (my !== gen) return;
        main.src = t.dataset.src; main.alt = t.dataset.alt;
        (main.decode ? main.decode() : Promise.resolve()).catch(() => {}).then(() => { if (my === gen) main.classList.remove('mm-leaving'); });
      }, 150);
    }));

    const form = root.querySelector('[data-mm-form]');
    if (!form) return;
    const price = root.querySelector('[data-mm-price]');
    const qty = form.querySelector('[data-mm-qty-input]');
    const submit = form.querySelector('[data-mm-submit]');
    const error = form.querySelector('[data-mm-error]');
    const mbuy = root.querySelector('[data-mm-mbuy]');
    form.querySelectorAll('input[name="id"][type="radio"]').forEach((r) => r.addEventListener('change', () => {
      if (price && r.dataset.price && price.textContent !== r.dataset.price) { price.classList.add('mm-swap'); setTimeout(() => { price.textContent = r.dataset.price; price.classList.remove('mm-swap'); }, 150); }
      if (mbuy) {
        const p = mbuy.querySelector('[data-mm-mbuy-price]'); if (p && r.dataset.price) p.textContent = r.dataset.price;
        const v = mbuy.querySelector('[data-mm-mbuy-variant]'); const t = r.closest('label')?.querySelector('b')?.textContent;
        if (v && t) v.textContent = `${t} · `;
      }
    }));
    /* scale cards: one frame glides to the chosen card instead of two borders toggling */
    const seg = form.querySelector('.mm-seg');
    if (seg) {
      const ind = document.createElement('span'); ind.className = 'mm-seg__ind'; ind.setAttribute('aria-hidden', 'true');
      seg.prepend(ind); seg.classList.add('has-ind');
      let first = true;
      const place = () => {
        const on = seg.querySelector('input:checked')?.closest('.mm-seg__opt'); if (!on) { ind.hidden = true; return; }
        ind.hidden = false;
        const s = seg.getBoundingClientRect(), o = on.getBoundingClientRect();
        if (first) ind.style.transition = 'none';
        ind.style.width = `${o.width}px`; ind.style.height = `${o.height}px`;
        ind.style.transform = `translate(${o.left - s.left}px, ${o.top - s.top}px)`;
        if (first) { setTimeout(() => { ind.style.transition = ''; }, 0); first = false; }
      };
      place(); addEventListener('resize', place, { passive: true });
      seg.addEventListener('change', place);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    }
    /* phones: floating buy bar once the real button has scrolled away above */
    if (mbuy) {
      mbuy.querySelector('[data-mm-mbuy-add]').addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })));
      new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top < 0;
        mbuy.classList.toggle('is-on', on);
        mbuy.setAttribute('aria-hidden', String(!on));
        mbuy.querySelector('[data-mm-mbuy-add]').tabIndex = on ? 0 : -1;
      }).observe(form.querySelector('[data-mm-submit]'));
    }
    form.querySelectorAll('[data-mm-qty]').forEach((b) => b.addEventListener('click', () => {
      qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.mmQty)));
    }));
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (submit.disabled) return;
      const label = submit.querySelector('span').textContent;
      submit.disabled = true; error.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      const fd = new FormData(form);
      if (drawer) { fd.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(',')); fd.append('sections_url', window.location.pathname); }
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'This decal could not be added to the cart. Please try again.');
        submit.classList.add('is-done'); swap(submit, 'Added ✓');
        if (drawer && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); drawer.renderContents(json); }
        else window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      } catch (err) {
        // network failure (TypeError) or a broken reply (SyntaxError): say what to do, not the browser's error text
        error.textContent = err instanceof TypeError || err instanceof SyntaxError ? 'Could not reach the shop. Check your internet connection and try again.' : err.message;
        error.hidden = false;
      } finally {
        setTimeout(() => { submit.classList.remove('is-done'); swap(submit, label); submit.disabled = false; }, 1800);
      }
    });
  });

  /* reviews anchor: point #mm-reviews at the app section that holds the review widget */
  const rev = document.querySelector('[id$="__mm_reviews"]');
  if (rev && !document.getElementById('mm-reviews')) rev.insertAdjacentHTML('afterbegin', '<span id="mm-reviews" style="position:relative;top:calc(-1 * var(--mm-header, 0px) - 2rem)"></span>');




  /* ---------- hero kit finder: go to the chosen aircraft-type collection ---------- */
  document.querySelectorAll('[data-mm-finder]').forEach((f) => f.addEventListener('submit', (e) => {
    e.preventDefault();
    const sel = f.querySelector('[data-mm-finder-type]');
    const opt = sel.selectedOptions[0];
    const scale = f.querySelector('[data-mm-finder-scale]')?.value || 'all';
    const shop = document.querySelector('[data-mm-shop]');
    if (shop && shop.mmFind && opt && opt.dataset.handle) {
      shop.mmFind(opt.dataset.handle, opt.dataset.label, scale);
      shop.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    } else if (opt && opt.value) {
      window.location.href = scale && scale !== 'all' ? `${opt.value}?scale=${encodeURIComponent(scale)}` : opt.value;
    }
  }));


  /* ---------- decal sheet cut-out: crop the product image to the decal sheet; numbered parts per product ---------- */
  let pinsData = null;
  const loadPins = (url) => { pinsData = pinsData || fetch(url).then((r) => (r.ok ? r.json() : {})).catch(() => ({})); return pinsData; };
  document.querySelectorAll('[data-mm-sheetcut]').forEach((box) => {
    const img = box.querySelector('img');
    const section = box.closest('[data-mm-anatomy]');
    const legend = section && section.querySelector('[data-mm-sheetlegend]');
    const included = section && section.querySelector('[data-mm-sheetincluded]');
    const applyCrop = (crop) => {
      const ratio = (crop.w * img.naturalWidth) / (crop.h * img.naturalHeight);
      box.style.aspectRatio = String(ratio);
      img.style.width = `${100 / crop.w}%`;
      img.style.left = `${-crop.x / crop.w * 100}%`;
      img.style.top = `${-crop.y / crop.h * 100}%`;
      box.classList.add('is-cut');
    };
    const detect = () => {
      try {
        const W = 300, H = Math.round(W * img.naturalHeight / img.naturalWidth);
        const c = document.createElement('canvas'); c.width = W; c.height = H;
        const ctx = c.getContext('2d', { willReadFrequently: true }); ctx.drawImage(img, 0, 0, W, H);
        const d = ctx.getImageData(0, 0, W, H).data;
        const blue = (i) => { const r = d[i], g = d[i + 1], b2 = d[i + 2]; return r > 130 && r < 225 && g > 195 && b2 > 215 && b2 - r > 18; };
        const rows = [];
        for (let y = 0; y < H; y++) { let n = 0; for (let x = 0; x < W; x++) n += blue((y * W + x) * 4); if (n / W > 0.35) rows.push(y); }
        if (!rows.length) return null;
        const y0 = rows[0], y1 = rows[rows.length - 1];
        const cols = [];
        for (let x = 0; x < W; x++) { let n = 0; for (let y = y0; y <= y1; y++) n += blue((y * W + x) * 4); if (n / (y1 - y0 + 1) > 0.35) cols.push(x); }
        if (!cols.length) return null;
        const pad = 0.006, x0 = Math.max(0, cols[0] / W - pad), yy = Math.max(0, y0 / H - pad);
        return { x: x0, y: yy, w: Math.min(1, (cols[cols.length - 1] + 1) / W + pad) - x0, h: Math.min(1, (y1 + 1) / H + pad) - yy };
      } catch (e) { return null; }
    };
    const run = async () => {
      const data = await loadPins(box.dataset.pinsUrl);
      const entry = data && data[box.dataset.handle];
      if (!entry && section && section.hasAttribute('data-mm-needs-pins')) return;
      const crop = entry && entry.crop ? { x: entry.crop[0], y: entry.crop[1], w: entry.crop[2], h: entry.crop[3] } : detect();
      if (!crop) { box.classList.add('is-full'); return; }
      applyCrop(crop);
      if (!entry || !entry.pins || !entry.pins.length || !legend) return;
      if (section) section.hidden = false;
      const esc = (t) => String(t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
      box.insertAdjacentHTML('beforeend', entry.pins.map(([x, y, t], i) =>
        `<button type="button" class="mm-pin" style="left:${x}%;top:${y}%;--i:${i}" data-mm-pin="${i}" aria-pressed="false" aria-label="${esc(t)}">${i + 1}</button>`).join(''));
      legend.innerHTML = entry.pins.map(([, , t, s2], i) =>
        `<li data-mm-legend="${i}" style="--i:${i}"><b>${String(i + 1).padStart(2, '0')}</b><span>${esc(t)}<small>${esc(s2 || '')}</small></span></li>`).join('');
      legend.hidden = false;
      armReveal(box);
      if (included) included.hidden = true;
    };
    box.addEventListener('contextmenu', (e) => e.preventDefault());
    const start = () => { if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true }); };
    // the sheet image is opacity 0 until cropped; some browsers then never start the lazy load. Nudge it when the section comes near.
    const nudge = () => { if (!img.complete || !img.naturalWidth) img.loading = 'eager'; };
    new IntersectionObserver((es, o) => { if (es.some((e) => e.isIntersecting)) { nudge(); o.disconnect(); } }, { rootMargin: '600px 0px' }).observe(box);
    setTimeout(nudge, 2500); // and in any case once the page has settled
    if (section && section.hasAttribute('data-mm-needs-pins')) {
      // hidden until we know this product has numbered parts (a hidden lazy image would never load)
      loadPins(box.dataset.pinsUrl).then((data) => { if (data && data[box.dataset.handle]) { section.hidden = false; start(); } });
    } else start();
  });

  /* data sheet: registration from the numbered sheet parts, when the product has no registration metafield */
  document.querySelectorAll('[data-mm-reg-from]').forEach((dl) => {
    loadPins(dl.dataset.mmRegFrom).then((data) => {
      const m = ((data[dl.dataset.handle] || {}).pins || []).map((p) => /^(Registrations?) ([A-Z0-9][A-Z0-9-]+(?: \/ [A-Z0-9-]+)*)$/.exec(p[2])).find(Boolean);
      if (!m) return;
      const row = document.createElement('div');
      row.innerHTML = '<dt></dt><dd class="mm-mono"></dd>';
      row.firstChild.textContent = m[1]; row.lastChild.textContent = m[2];
      dl.prepend(row);
    });
  });


  /* ---------- horizontal product rows with prev/next buttons ---------- */
  document.querySelectorAll('[data-mm-row]').forEach((row) => {
    const track = row.querySelector('[data-mm-row-track]');
    const prev = row.querySelector('[data-mm-row-prev]'), next = row.querySelector('[data-mm-row-next]');
    if (!track) return;
    // one step = exactly one card (card width + gap), so the row lands on card edges like a swipe would
    const step = () => { const a = track.children[0], b = track.children[1]; return a && b ? b.offsetLeft - a.offsetLeft : Math.max(track.clientWidth * 0.8, 240); };
    const sync = () => {
      const atStart = track.scrollLeft < 4, atEnd = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      row.classList.toggle('is-at-end', atEnd); row.classList.toggle('is-at-start', atStart);
      const nav = row.querySelector('.mm-new__nav'); if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 4;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true }); addEventListener('resize', sync, { passive: true }); sync();
  });


  /* ---------- "contact us" links jump to the theme's contact form on the page ---------- */
  document.querySelectorAll('[data-mm-contact]').forEach((a) => a.addEventListener('click', (e) => {
    const form = document.querySelector('form#ContactForm, .contact form, [id*="contact_form"]');
    if (!form) return;
    e.preventDefault();
    form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }));

  /* ---------- sheet anatomy: pins and legend appear once, when the sheet scrolls into view ---------- */
  const armReveal = (stage) => {
    stage.querySelectorAll('.mm-pin').forEach((p, i) => { if (!p.style.getPropertyValue('--i')) p.style.setProperty('--i', i); });
    const legend = stage.closest('[data-mm-anatomy]')?.querySelector('.mm-legend');
    legend && legend.querySelectorAll('li').forEach((l, i) => { if (!l.style.getPropertyValue('--i')) l.style.setProperty('--i', i); });
    stage.classList.add('mm-arm');
    const live = () => { stage.classList.add('mm-live'); io.disconnect(); };
    const io = new IntersectionObserver((es) => es.some((e) => e.isIntersecting) && live(), { threshold: 0.35 });
    io.observe(stage);
    setTimeout(live, 6000); // never leave the sheet unlabelled if the observer does not fire
  };
  document.querySelectorAll('.mm-anatomy').forEach(armReveal);
  document.querySelectorAll('[data-mm-anatomy]').forEach((root) => {
    const pick = (i) => {
      root.querySelectorAll('[data-mm-pin]').forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.mmPin === i)));
      root.querySelectorAll('[data-mm-legend]').forEach((l) => l.classList.toggle('mm-on', l.dataset.mmLegend === i));
    };
    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-mm-pin],[data-mm-legend]');
      if (t) pick(t.dataset.mmPin ?? t.dataset.mmLegend);
    });
    if (matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseover', (e) => {
        const l = e.target.closest('[data-mm-legend]');
        if (l) pick(l.dataset.mmLegend);
      });
    }
  });

  /* ---------- shipping region hint on product page ---------- */
  // rates are written in EUR; a visitor shopping in another currency also sees an approximate converted amount
  const cur = window.Shopify && Shopify.currency;
  const fx = (root) => {
    const rate = cur && cur.active !== 'EUR' && Number(cur.rate);
    if (!rate) return;
    root.querySelectorAll('.mm-region__rate').forEach((b) => {
      const eur = parseFloat(b.textContent.replace(',', '.').replace(/[^\d.]/g, ''));
      if (!eur || b.nextElementSibling?.classList.contains('mm-region__fx')) return;
      const s = document.createElement('span');
      s.className = 'mm-region__fx';
      s.textContent = ` (about ${new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active }).format(eur * rate)})`;
      b.after(s);
    });
  };
  /* shipping region boxes (product page + cart): one delegated handler, because the cart drawer re-renders its box
     on every cart change; the visitor's choice is remembered and applied to every box, so PDP and cart agree */
  const REGION_KEY = 'mm-region';
  const readRegion = () => { try { return localStorage.getItem(REGION_KEY); } catch (e) { return null; } };
  const showRegion = (box, value, animate) => {
    const select = box.querySelector('select'), text = box.querySelector('[data-mm-region-text]');
    const t = box.querySelector(`template[data-for="${value}"]`); if (!select || !text || !t) return;
    select.value = value;
    if (!animate) { text.innerHTML = t.innerHTML; fx(text); return; }
    text.classList.add('mm-swap');
    setTimeout(() => { text.innerHTML = t.innerHTML; fx(text); text.classList.remove('mm-swap'); }, 150);
  };
  const initRegions = () => document.querySelectorAll('[data-mm-region]:not([data-mm-init])').forEach((box) => {
    box.dataset.mmInit = '1';
    const stored = readRegion(), select = box.querySelector('select');
    if (stored && select && select.value !== stored) showRegion(box, stored, false); else fx(box.querySelector('[data-mm-region-text]') || box);
  });
  initRegions();
  new MutationObserver(initRegions).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-mm-region]'); if (!box || e.target.tagName !== 'SELECT') return;
    try { localStorage.setItem(REGION_KEY, e.target.value); } catch (err) { /* private mode */ }
    document.querySelectorAll('[data-mm-region]').forEach((b) => showRegion(b, e.target.value, b === box));
  });

  /* ---------- marquee runs only while visible (saves work on long pages, stops in background tabs) ---------- */
  document.querySelectorAll('.mm-facts__track').forEach((track) => {
    const io = new IntersectionObserver((es) => es.forEach((e) => { track.style.animationPlayState = e.isIntersecting ? '' : 'paused'; }));
    io.observe(track);
    document.addEventListener('visibilitychange', () => { track.style.animationPlayState = document.hidden ? 'paused' : ''; });
  });

  /* filter rows: show the chevron only when chips overflow; it unfolds/folds the row */
  const frows = [...document.querySelectorAll('.mm-frow')];
  const checkRows = () => frows.forEach((row) => {
    const chips = row.querySelector('.mm-fchips'), btn = row.querySelector('[data-mm-frow-toggle]');
    if (!chips || !btn) return;
    if (!row.classList.contains('is-open')) btn.hidden = chips.scrollWidth <= chips.clientWidth + 2;
  });
  checkRows(); addEventListener('resize', checkRows, { passive: true });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mm-frow-toggle]'); if (!btn) return;
    const row = btn.closest('.mm-frow'); const chips = row.querySelector('.mm-fchips');
    // chips that were out of sight get a short stagger when the row unfolds; the ones already visible stay put
    const edge = chips.getBoundingClientRect().right; let k = 0;
    row.querySelectorAll('.mm-chip').forEach((c) => { c.style.removeProperty('--i'); if (c.getBoundingClientRect().left >= edge - 8) c.style.setProperty('--i', k++); });
    const open = row.classList.toggle('is-open');
    row.classList.toggle('mm-frow--reveal', open && !reduce);
    btn.setAttribute('aria-expanded', String(open)); btn.setAttribute('aria-label', open ? 'Show fewer options' : 'Show all options');
    if (!open) checkRows();
  });

  /* generic "show more": reveals the next N hidden cards in the same section */
  /* data-mm-reveal-max caps the clicks; afterwards a sibling [data-mm-reveal-all] link ("Browse all") takes the button's place */
  document.querySelectorAll('[data-mm-reveal]').forEach((b) => { let clicks = 0; b.addEventListener('click', () => {
    const sec = b.closest('section'); const step = Number(b.dataset.mmReveal) || 8; const max = Number(b.dataset.mmRevealMax) || Infinity;
    const hidden = [...sec.querySelectorAll('.mm-card[hidden]')];
    hidden.slice(0, step).forEach((c) => { c.hidden = false; });
    clicks += 1;
    if (hidden.length <= step || clicks >= max) {
      const all = b.parentElement.querySelector('[data-mm-reveal-all]');
      if (all) { b.hidden = true; all.hidden = false; } else b.parentElement.hidden = true;
    }
  }); });

  /* search: reveal the rest of the "more results" group */
  document.querySelectorAll('[data-mm-also-more]').forEach((b) => b.addEventListener('click', () => {
    b.closest('details').querySelectorAll('.mm-card[hidden]').forEach((c) => { c.hidden = false; });
    b.parentElement.hidden = true;
  }));

  /* ---------- live search (header): the whole catalogue as one small JSON (Liquid-rendered index), filtered locally
     on every keystroke. Matches title, airline, sheet number and registration; "dc3" finds "DC-3", one typo is tolerated. ---------- */
  const lives = [...document.querySelectorAll('[data-mm-live]')];
  if (lives.length) {
    const root = window.Shopify?.routes?.root || '/';
    let index = null, loading = null;
    const compact = mmCompact, tokens = mmTokens, near = mmNear;
    const load = () => loading || (loading = (async () => {
      try { const c = sessionStorage.getItem('mm-live-index'); if (c) { index = JSON.parse(c); } } catch (e) { /* no cache */ }
      if (index) return index;
      const res = await fetch(`${root}collections/all?view=index`); // plain request: an Accept: application/json header makes Shopify look for a .json template and 404
      const text = (await res.text()).trim();
      index = JSON.parse(text.slice(text.indexOf('['), text.lastIndexOf(']') + 1));
      index.forEach((it) => { it.c = compact(it.t + ' ' + it.a); it.k = tokens(it.t + ' ' + it.a); it.rc = compact(it.r); it.nc = compact(it.n); });
      try { sessionStorage.setItem('mm-live-index', JSON.stringify(index)); } catch (e) { /* fine */ }
      return index;
    })());
    const score = (it, q, qt) => {
      let sc = 0;
      if (it.c.startsWith(q)) sc += 60; else if ((/\d/.test(q) || q.length >= 5) && it.c.includes(q)) sc += 40;
      if (it.rc && it.rc.startsWith(q)) sc += 70; if (it.nc && it.nc.startsWith(q)) sc += 70;
      for (const t of qt) {
        if (it.k.some((k) => k.startsWith(t))) sc += 10;
        else if (it.k.some((k) => near(t, k) || (k.length > t.length && near(t, k.slice(0, t.length))))) sc += 5;
        else if (!((/\d/.test(t) || t.length >= 5) && it.c.includes(t))) return 0;
      }
      return sc;
    };
    const esc = (t) => String(t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));
    const mark = (title, qt) => { // bold the matched word starts
      let out = esc(title);
      qt.filter((t) => t.length >= 2).forEach((t) => { out = out.replace(new RegExp(`(^|[^a-z0-9])(${t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'i'), '$1<mark>$2</mark>'); });
      return out;
    };
    lives.forEach((form) => {
      const input = form.querySelector('[data-mm-live-input]'), out = form.querySelector('[data-mm-live-out]'), list = form.querySelector('[data-mm-live-list]');
      const empty = form.querySelector('[data-mm-live-empty]'), all = form.querySelector('[data-mm-live-all]'), hint = form.querySelector('[data-mm-live-hint]');
      let active = -1, timer = 0;
      const clear = () => { out.hidden = true; list.innerHTML = ''; if (hint) hint.hidden = false; input.setAttribute('aria-expanded', 'false'); active = -1; };
      const render = () => {
        const raw = input.value.trim(); if (raw.length < 2) { clear(); return; }
        const q = compact(raw), qt = tokens(raw);
        const hits = index.map((it) => [score(it, q, qt), it]).filter((x) => x[0] > 0).sort((a, b) => b[0] - a[0]).map((x) => x[1]);
        const shown = hits.slice(0, 8);
        list.innerHTML = shown.map((it, i) => {
          const y = (it.t.match(/\((\d{4})\)/) || [])[1]; const name = it.t.replace(/\s*\(\d{4}\)/, '').replace(/\s+/g, ' '); // some titles carry double spaces
          return `<li role="option" id="${list.id}-${i}" aria-selected="false"><a href="${root}products/${esc(it.h)}" tabindex="-1"><img src="${esc(it.i)}" alt="" width="80" height="60" loading="lazy"><span><b>${mark(name, qt)}</b><small>${y ? y + ' · ' : ''}${esc(it.p)}${it.r ? ' · ' + esc(it.r) : ''}</small></span></a></li>`;
        }).join('');
        if (empty) { empty.hidden = hits.length > 0; empty.innerHTML = hits.length ? '' : `No decals match “${esc(raw)}”. Try the aircraft type (for example “737-200”) or the airline, or <a href="${root}collections/all">browse all decals</a>.`; }
        if (all) { all.hidden = hits.length === 0; all.href = `${root}search?q=${encodeURIComponent(raw)}&options%5Bprefix%5D=last`; all.textContent = hits.length > shown.length ? `Show all ${hits.length} results for “${raw}” →` : `Open the search page for “${raw}” →`; }
        out.hidden = false; if (hint) hint.hidden = true; input.setAttribute('aria-expanded', 'true'); active = -1;
      };
      const update = () => { clearTimeout(timer); if (!index) { load().then(render).catch(() => {}); return; } timer = setTimeout(render, 40); };
      input.addEventListener('focus', () => { load().catch(() => {}); }, { once: true });
      input.addEventListener('input', update);
      input.addEventListener('keydown', (e) => {
        const opts = [...list.querySelectorAll('[role="option"]')]; if (!opts.length) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
          opts.forEach((o, i) => o.setAttribute('aria-selected', String(i === active))); input.setAttribute('aria-activedescendant', opts[active].id);
        } else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); location.href = opts[active].querySelector('a').href; }
      });
      form.closest('[data-mm-search]')?.addEventListener('toggle', (e) => { if (e.target.open) { load().catch(() => {}); setTimeout(() => input.focus(), 30); } });
    });
  }

  /* header panels: one open at a time, close on outside click and Esc; the phone sheet closes on Esc */
  const menus = [...document.querySelectorAll('[data-mm-menu]')];
  // switching from one open panel to another skips the entrance (like a second tooltip): the visitor is already "in" the menu
  menus.forEach((d) => d.addEventListener('toggle', () => {
    if (!d.open) return;
    const wasOpen = menus.some((o) => o !== d && o.open);
    d.classList.toggle('is-instant', wasOpen);
    menus.forEach((o) => { if (o !== d) o.open = false; });
  }));
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-mm-menu]')) menus.forEach((o) => { o.open = false; }); });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    menus.forEach((o) => { if (o.open) { o.open = false; o.querySelector('summary')?.focus(); } });
    const dr = document.querySelector('[data-mm-drawer][open]'); if (dr) { dr.open = false; dr.querySelector('summary')?.focus(); }
  });

  /* header: scroll edge shadow only when content is beneath the bar */
  const nav = document.querySelector('.mm-nav');
  if (nav) { const edge = () => nav.toggleAttribute('data-scrolled', scrollY > 4); edge(); addEventListener('scroll', edge, { passive: true }); }

  /* cart drawer: swipe right to close (touch/pen). 1:1 tracking with the grab offset, rubber-band past the left edge,
     release decides by the sign of the velocity (a flick back to the left keeps it open), the close continues at the finger's speed. */
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && !reduce) {
    let inner, startX, startY, dx = 0, committed = false, hist = [];
    const width = () => inner.getBoundingClientRect().width;
    const rubber = (x, w, c = 0.55) => (x * w * c) / (w + c * Math.abs(x));
    cartDrawer.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;
      inner = e.target.closest('.drawer__inner'); if (!inner) return;
      if (e.target.closest('input, select, textarea, button, a, [data-mm-scalepop]')) { inner = null; return; }
      startX = e.clientX; startY = e.clientY; dx = 0; committed = false; hist = [[e.clientX, e.timeStamp]];
    }, { passive: true });
    cartDrawer.addEventListener('pointermove', (e) => {
      if (!inner) return;
      const mx = e.clientX - startX, my = e.clientY - startY;
      if (!committed) {
        if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;          // hysteresis
        if (Math.abs(my) > Math.abs(mx)) { inner = null; return; }   // vertical: it's a scroll
        committed = true; try { inner.setPointerCapture(e.pointerId); } catch (_) {} inner.classList.add('is-dragging');
      }
      dx = mx >= 0 ? mx : rubber(mx, width());                      // right follows 1:1, left rubber-bands
      inner.style.transform = `translateX(${dx}px)`;
      hist.push([e.clientX, e.timeStamp]); if (hist.length > 6) hist.shift();
    }, { passive: true });
    const release = (e) => {
      if (!inner || !committed) { inner = null; return; }
      const [x0, t0] = hist[0], [x1, t1] = hist[hist.length - 1];
      const v = t1 > t0 ? (x1 - x0) / (t1 - t0) * 1000 : 0;          // px/s, positive = towards closing
      const w = width(); const el = inner; inner = null;
      el.classList.remove('is-dragging');
      const close = v > 250 || (dx > w * 0.4 && v > -250);
      if (close) {
        const remaining = Math.max(0, w - dx);
        const ms = Math.min(280, Math.max(120, Math.abs(v) > 50 ? (remaining / Math.abs(v)) * 1000 : 220));
        el.style.transition = `transform ${Math.round(ms)}ms var(--mm-ease-out)`;
        el.style.transform = 'translateX(100%)';
        setTimeout(() => { cartDrawer.close(); el.style.transition = ''; el.style.transform = ''; }, ms);
      } else {
        el.classList.add('is-settling'); el.style.transform = '';
        setTimeout(() => el.classList.remove('is-settling'), 240);
      }
    };
    cartDrawer.addEventListener('pointerup', release); cartDrawer.addEventListener('pointercancel', release);
  }

  /* cart drawer: removing a line can be undone for 6 s (the drawer re-renders on every update, so the bar is re-attached) */
  if (cartDrawer) {
    let pending = null, timer = null;
    const bar = document.createElement('div'); bar.className = 'mm-undo'; bar.setAttribute('role', 'status');
    bar.innerHTML = '<span></span><button type="button" class="mm-press" data-mm-undo>Undo</button>';
    const attach = (muts) => {
      if (!pending) return;
      if (muts && muts.every((m) => bar.contains(m.target))) return;      // our own bar changing must not re-trigger us
      const host = cartDrawer.querySelector('.drawer__inner'); if (!host) return;
      // below the title; the empty state hides the header, so there the bar sits above "Your cart is empty"
      const empty = cartDrawer.classList.contains('is-empty') ? host.querySelector('.cart-drawer__warnings') : null;
      const home = empty || host;
      if (bar.parentElement !== home) { if (empty) empty.prepend(bar); else { const after = host.querySelector('.drawer__header'); after ? after.after(bar) : host.prepend(bar); } }
      const txt = `${pending.title} removed`; const span = bar.querySelector('span');
      if (span.textContent !== txt) span.textContent = txt;
    };
    const clear = () => { pending = null; clearTimeout(timer); bar.remove(); };
    cartDrawer.addEventListener('click', (e) => {
      const rm = e.target.closest('cart-remove-button'); if (!rm) return;
      const line = rm.closest('.cart-item'); const input = line && line.querySelector('[data-quantity-variant-id]');
      if (!input) return;
      pending = { id: Number(input.dataset.quantityVariantId), qty: Number(input.value) || 1, title: (line.querySelector('.cart-item__name')?.textContent || 'Decal').trim().replace(/ Decal$/, '') };
      clearTimeout(timer); timer = setTimeout(clear, 6000);
    }, true);
    bar.addEventListener('click', async (e) => {
      if (!e.target.closest('[data-mm-undo]') || !pending) return;
      const { id, qty } = pending; clear();
      const sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity: qty, sections, sections_url: window.location.pathname }) });
      const json = await res.json();
      if (res.ok && !json.status) { cartDrawer.classList.remove('is-empty'); cartDrawer.renderContents(json); }
    });
    new MutationObserver(attach).observe(cartDrawer, { childList: true, subtree: true });
    cartDrawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') clear(); });
  }

  /* footer "Cancel contract": proxies the withdrawal app's floating button (hidden on phones, where it covered the shop) */
  const wbLink = document.querySelector('[data-mm-wb]');
  if (wbLink) {
    const wbBtn = () => document.getElementById('wb-trigger-btn');
    const showWb = () => { if (wbBtn()) wbLink.closest('[data-mm-wb-item]').hidden = false; };
    showWb(); if (!wbBtn()) { const mo = new MutationObserver(() => { if (wbBtn()) { showWb(); mo.disconnect(); } }); mo.observe(document.body, { childList: true }); }
    wbLink.addEventListener('click', (e) => { const b = wbBtn(); if (!b) return; e.preventDefault(); b.click(); });
  }

  /* footer country/language: plain selects that submit the localization form on change */
  document.querySelectorAll('[data-mm-loc]').forEach((sel) => sel.addEventListener('change', () => sel.form.submit()));

  /* cart counter pulses when the cart changes (the drawer re-renders #cart-icon-bubble on every update) */
  const bubbleHost = document.getElementById('cart-icon-bubble');
  if (bubbleHost && 'MutationObserver' in window) {
    new MutationObserver(() => {
      const b = bubbleHost.querySelector('.cart-count-bubble');
      if (b && !reduce) b.classList.add('mm-pulse');
    }).observe(bubbleHost, { childList: true });
  }

  /* ---------- request form: no double submit ---------- */
  document.querySelectorAll('form[data-mm-once]').forEach((f) => f.addEventListener('submit', () => {
    const b = f.querySelector('[type="submit"]');
    setTimeout(() => { b.disabled = true; b.textContent = 'Sending…'; }, 0);
  }));
  /* ---------- customer gallery lightbox: native <dialog>, arrows/keys step through all photos of the page ---------- */
  document.querySelectorAll('[data-mm-lb]').forEach((lb) => {
    const sec = lb.closest('section'); if (!sec) return;
    const thumbs = [...sec.querySelectorAll('[data-mm-lb-src]')]; if (!thumbs.length) return;
    const img = lb.querySelector('[data-mm-lb-img]'), by = lb.querySelector('[data-mm-lb-by-out]'), cap = lb.querySelector('[data-mm-lb-cap-out]'), count = lb.querySelector('[data-mm-lb-count]');
    let i = 0;
    if (thumbs.length < 2) lb.setAttribute('data-single', '');
    const show = (n, swap) => {
      i = (n + thumbs.length) % thumbs.length; const t = thumbs[i];
      const set = () => { img.src = t.dataset.mmLbSrc; if (t.dataset.mmLbW) { img.width = t.dataset.mmLbW; img.height = t.dataset.mmLbH; } img.alt = t.querySelector('img')?.alt || ''; by.textContent = t.dataset.mmLbBy || ''; cap.textContent = t.dataset.mmLbCap || ''; count.textContent = `${i + 1} / ${thumbs.length}`; };
      if (!swap) return set();
      img.classList.add('mm-swap'); setTimeout(() => { set(); img.decode?.().catch(() => {}).finally(() => img.classList.remove('mm-swap')); }, 150);
    };
    thumbs.forEach((t, n) => t.addEventListener('click', () => { show(n); lb.showModal(); lb.querySelector('[data-mm-lb-close]').focus(); }));
    lb.querySelector('[data-mm-lb-close]').addEventListener('click', () => lb.close());
    lb.querySelector('[data-mm-lb-prev]').addEventListener('click', () => show(i - 1, true));
    lb.querySelector('[data-mm-lb-next]').addEventListener('click', () => show(i + 1, true));
    lb.addEventListener('click', (e) => { if (e.target === lb) lb.close(); });
    lb.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') show(i - 1, true); if (e.key === 'ArrowRight') show(i + 1, true); });
    lb.addEventListener('close', () => { thumbs[i].focus(); img.removeAttribute('src'); });
  });
  /* ---------- product page: "Built by customers" row, fed by the gallery page (no second data source).
     The whole gallery page is fetched once per session and reduced to {handle: {by, n, thumbs}} in sessionStorage. ---------- */
  document.querySelectorAll('[data-mm-cphotos]').forEach(async (box) => {
    try {
      const key = 'mm-cgal2:' + box.dataset.mmCphotosSrc; let map = null;
      try { map = JSON.parse(sessionStorage.getItem(key)); } catch (e) {}
      if (!map) {
        const r = await fetch(box.dataset.mmCphotosSrc); if (!r.ok) return;
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html'); map = {};
        doc.querySelectorAll('[data-mm-handle]').forEach((b) => {
          /* several builders of the same decal are merged: names joined, photos summed, thumbs from the first entries */
          const imgs = [...b.querySelectorAll('.mm-cgal__thumb img')]; const h = b.dataset.mmHandle; if (!h || !imgs.length) return;
          const m = map[h] || (map[h] = { builds: 0, n: 0, thumbs: [] }); m.builds += 1;
          m.n += imgs.length; m.thumbs = m.thumbs.concat(imgs.map((i) => i.getAttribute('src'))).slice(0, 3);
        });
        try { sessionStorage.setItem(key, JSON.stringify(map)); } catch (e) {}
      }
      const b = map[box.dataset.mmCphotos]; if (!b) return;
      box.querySelector('.mm-cphotos__thumbs').replaceChildren(...b.thumbs.map((src) => Object.assign(new Image(64, 64), { src, alt: '', loading: 'lazy' })));
      /* no builder names here (they live in the gallery and would grow endlessly): count of builds + photos */
      box.querySelector('.mm-cphotos__meta').innerHTML = `<b>${b.builds} build${b.builds === 1 ? '' : 's'}</b><span>${b.n} photo${b.n === 1 ? '' : 's'}</span>`;
      box.hidden = false;
    } catch (e) { /* gallery unavailable: row stays hidden */ }
  });
})();

/* ---------- image protection (2026-10-11): no context menu / drag on product, gallery and story imagery. A deterrent, not DRM. ---------- */
(() => {
  const SEL = '.mm-card__img, .mm-stage, .mm-thumb, .mm-cgal__thumb, .mm-lb, .mm-sheetcut, .mm-tail, .mm-tail-media, .mm-new__card, .mm-xsell';
  document.addEventListener('contextmenu', (e) => { const b = e.target.closest && e.target.closest(SEL); if (b && b.querySelector('img')) e.preventDefault(); });
  document.addEventListener('dragstart', (e) => { if (e.target.tagName === 'IMG' && e.target.closest(SEL)) e.preventDefault(); });
})();
